/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutStoreController', function ($scope, $q, $element, $http, ControlService, CommonUtils, Validation) {
            $scope.Model = $scope.Model || {};
            $scope.Control = $scope.Control || {};

            var controlName = 'Store';
            $scope.registerControl(controlName, $element.get(0));

            $scope.Control.IsValid = true;
            $scope.Control.Selected = 0;
            $scope.Control.Map = false;
            $scope.Control.Text = {};
            $scope.Control.HasGoogleInput = false;
            $scope.Control.ShowStores = false;
            $scope.Control.HasSearch = false;
            $scope.Control.HasGoogleSearch = false;

            //get configuration from page view model because we need this info before getCheckoutData
            $scope.Control.HasStoreSorting = $('.x-checkoutorder').data('storesorting');
            var controlService = $scope.Control.HasStoreSorting ? "GetPartnerData" : "GetStoreData";
            
            var searchObj = [];
            var validators = [];
            var initiallyValidated = false;
            var activeAjaxCall = false;

            var initialState = {
                ItemCode: "shops",
                GeoAreaId: '',
                ShopIncludedDelivery: 1,
                Latitude: '',
                Longitude: ''
            };

            var $storesField = $('.form-row.stores', $element);

            var setStore = function (store) {
                var deferred = $q.defer();
                ControlService.invokeCheckout($scope, $element, 'SetStore', store).then(function (setResponse) {
                    $scope.setControlValue(controlName, store);
                    if ($scope['Order'] && $scope['Order'].Wrapper && typeof ($scope['Order'].Wrapper.reload) == 'function') {
                        $scope['Order'].Wrapper.reload().then(function (orderResponse) {
                            deferred.resolve();
                            $scope.Control.Loading = false;
                        }, function (orderError) {
                            deferred.reject(orderError);
                            $scope.Control.Loading = false;
                        });
                    } else {
                        deferred.resolve();
                        $scope.Control.Loading = false;
                    }
                }, function (setError) {
                    deferred.reject(setError);
                    $scope.Control.Loading = false;
                });
                return deferred.promise;
            };

            var setMap = function (store) {
                if (store && store.Id && store.Latitude && store.Longitude) {
                    checkoutConfig.CheckoutStoreMapConfig(store);
                    $scope.Control.Map = true;
                } else {
                    $scope.Control.Map = false;
                }
            };

            var errorCallback = function (error) {
                var message = "";
                // Check for known errors
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        message = "This website does not have permission to use " +
                            "the Geolocation API";
                        break;
                    case error.POSITION_UNAVAILABLE:
                        message = "The current position could not be determined.";
                        break;
                    case error.PERMISSION_DENIED_TIMEOUT:
                        message = "The current position could not be determined " +
                            "within the specified timeout period.";
                        break;
                }

                if (message == "") {
                    var strErrorCode = error.code.toString();
                    message = "The position could not be determined due to " +
                        "an unknown error (Code: " + strErrorCode + ").";
                }
            };

            $scope.Control.showStores = function () {
                if (!$scope.Control.ShowStores) {
                    $scope.Control.ShowStores = true;
                    if ($scope.Control.HasSearch) {
                        angular.element('input.search', $element).ready(function () {
                            $('input.search', $element).focus();
                        });
                    }
                } else {
                    $scope.Control.hideStores();
                }
            };

            $scope.Control.hideStores = function () {
                $scope.Control.ShowStores = false;
                if ($scope.Control.HasSearch) {
                    $scope.Control.resetSearch();                   
                }
            };

            $scope.Control.resetSearch = function () {
                $('input.search', $element).val('');
                if (checkoutOverrides && checkoutOverrides.Generic && typeof checkoutOverrides.Generic.ResetListSearch === 'function') {
                    checkoutOverrides.Generic.ResetListSearch(searchObj);
                }               
            };

            $scope.Control.setSelected = function (storeId) {

                var selectedStore = $scope.Control.HasStoreSorting ?
                    _.first(_.filter($scope.Model.Data.Stores.Items[0], function (x) { return x.Id == storeId; })) : _.first(_.filter($scope.Model.Data.Stores, function (x) { return x.Id == storeId; }));

                $scope.Control.Selected = selectedStore.Id;
                $scope.Control.setStore();
            };

            $scope.Control.setStore = function () {

                var selectedStore = $scope.Control.HasStoreSorting ?
                    _.first(_.filter($scope.Model.Data.Stores.Items[0], function (x) { return x.Id == $scope.Control.Selected; })) : _.first(_.filter($scope.Model.Data.Stores, function (x) { return x.Id == $scope.Control.Selected; }));

                if (!selectedStore) return;

                $scope.Control.Text = {};
                $scope.Control.SelectedError = false;
                $scope.Control.Loading = true;
                angular.extend($scope.Control.Text, selectedStore || {});
                $scope.setControlValue(controlName, selectedStore);

                if ($scope.PickupPoint && $scope.PickupPoint.Current)
                    $scope.setControlValue("PickupPoint", null);

                if (checkoutConfig.hasMap)
                    $scope.Control.SetMap(false);

                if (selectedStore.CompanyId) {
                    var shScope = angular.element('.x-control.x-angular-control.x-checkoutshippingmethod').scope();
                    $scope.Control.setStoreShippingMethod(shScope, selectedStore.Id);
                    shScope.Control.setSelectedCompany(selectedStore.CompanyId);
                }

                setStore(selectedStore).then(function (response) {
                    $scope.Control.Loading = false;
                }, function (error) {
                    $scope.Control.Loading = false;
                    throw error;
                });

                $scope.Control.SelectedError = false;
            };

            $scope.Control.SetMap = function (reset) {
                if (angular.element('.x-control.x-angular-control.x-checkoutdeliverypoint').scope().Control.Selected.Code !== 'fromStore') return;

                if (typeof (GMaps) === 'function') setMap($scope.Control.Text);

                if (reset && typeof (reset) !== "undefined") {
                    var selectedStore = $scope.Control.HasStoreSorting ?
                        _.first(_.filter($scope.Model.Data.Stores.Items[0], function (x) { return x.Id == $scope.Control.Selected; })) : _.first(_.filter($scope.Model.Data.Stores, function (x) { return x.Id == $scope.Control.Selected; }));

                    if (selectedStore) $element.get(0).set();
                }
            };

            $scope.Control.geoLocation = function () {
                if (window.navigator.geolocation) {
                    window.navigator.geolocation.enableHighAccuracy = false;
                    window.navigator.geolocation.getCurrentPosition($scope.Control.getStores, errorCallback);
                } else {
                    alert("Geolocation is not supported by this browser.");
                }

                //reset google search input
                if ($scope.Control.HasGoogleInput) {
                    document.getElementById("google-search-input").value = "";
                    $scope.Control.GoogleInput = false;
                }
            };

            $scope.Control.googleSearch = function () {

                var googleInput = document.getElementById("google-search-input");
                var autocomplete = new google.maps.places.Autocomplete(googleInput/*, options*/);

                $scope.Control.HasGoogleInput = true;

                autocomplete.addListener("place_changed", function () {
                    //prevent multiple events
                    if (activeAjaxCall) return;

                    //use the coordinates from google search
                    var place = autocomplete.getPlace();

                    if (typeof place.geometry === 'undefined') return;

                    var coords = {
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng()
                    };

                    $scope.Control.getStores(coords);
                    
                });
            };

            $scope.Control.getStores = function (coords) {
                $storesField.addClass('x-loading');
                activeAjaxCall = true;

                var currentState = {
                    ItemCode: "shops",
                    GeoAreaId: '',
                    ShopIncludedDelivery: 1,
                    Latitude: coords.lat || coords.coords.latitude,
                    Longitude: coords.lng || coords.coords.longitude
                };

                $element.get(0).data = currentState;

                $http({
                    async: true,
                    method: "POST",
                    contentType: 'application/json; charset=UTF-8',
                    url: document.location.protocol.toLowerCase() + '//' + document.location.host.toLowerCase() + '/services/api/StoreLocator/QueryPartners',
                    data: currentState
                }).then(function mySuccess(response) {
                    var stores = response.data.data.Items[0];
                    $scope.Model.Data.Stores.Items[0] = stores;
                    $scope.Control.setStoreShippingCost();
                    activeAjaxCall = false;
                    $storesField.removeClass('x-loading');
                }, function myError(response) {
                    console.log(response);
                });

            };

            $scope.Control.setStoreShippingMethod = function (shScope, storeId) {
                _.each(shScope.Model.Data.Methods, function (method) {
                    _.each(method.Options, function (option) {
                        if (option.StoreId == storeId)
                            shScope.Control.SelectedMethod = method.Id;
                    });
                });   
            };

            $scope.Control.setStoreShippingCost = function () {
                var shScope = angular.element('.x-control.x-angular-control.x-checkoutshippingmethod').scope();
                var storeMethods = _.filter(shScope.Model.Data.Methods, function (method) { return method.Code.indexOf('fromStore') > -1; });
                var options = _.flatten(_.pluck(storeMethods, 'Options'));

                //if shipping product groups for partners            
                if (shScope.Model.Data.PartnerMethodsFilteredByShippingProductGroups) {
                    //get available store ids
                    var storeIds = options.map(function (i) { return i.StoreId });

                    if ($scope.Control.HasStoreSorting) {
                        //filter stores with available store ids
                        $scope.Model.Data.Stores.Items[0] = $scope.Model.Data.Stores.Items[0].filter(function (s) { return storeIds.indexOf(s.Id) >= 0; });
                    } else {
                        //filter stores with available store ids
                        $scope.Model.Data.Stores = $scope.Model.Data.Stores.filter(function (s) { return storeIds.indexOf(s.Id) >= 0; });

                        if ($scope.Model.Data.GroupedStores[0]) {
                            //filter grouped stores with available store ids
                            $scope.Model.Data.GroupedStores.forEach(function (gs) {
                                gs.Items = gs.Items.filter(function (s) { return storeIds.indexOf(s.Id) >= 0; });
                            });
                            //remove empty groups
                            $scope.Model.Data.GroupedStores = $scope.Model.Data.GroupedStores.filter(function (gs) {  return gs.Items.length > 0; });
                        }
                    }
                }
                
                var storesArray = [], groupedStoresArray = [];

                if ($scope.Control.HasStoreSorting) {
                    //add info about shipping cost in stores
                    storesArray = $scope.Model.Data.Stores.Items[0];
                    $scope.Control.addShippingCost(storesArray, options);
                } else {
                    //add info about shipping cost in stores
                    storesArray = $scope.Model.Data.Stores;
                    $scope.Control.addShippingCost(storesArray, options);

                    if ($scope.Model.Data.GroupedStores[0]) {
                        //add info about shipping cost in grouped stores
                        groupedStoresArray = $scope.Model.Data.GroupedStores;
                        groupedStoresArray.forEach(function (group) {
                            storesArray = group.Items;
                            $scope.Control.addShippingCost(storesArray, options);
                        });
                    }
                }

                //if there is selected shipping company
                if (shScope.Control.SelectedCompany != 0 && $scope['Order'].Current.Store.Id != 0) {
                    //find store related to this company
                    var selectedStore = $scope.Control.HasStoreSorting ?
                        _.filter($scope.Model.Data.Stores.Items[0], function (x) { return x.CompanyId == shScope.Control.SelectedCompany && x.Id == $scope['Order'].Current.Store.Id; }) :
                        _.filter($scope.Model.Data.Stores, function (x) { return x.CompanyId == shScope.Control.SelectedCompany && x.Id == $scope['Order'].Current.Store.Id; });
                    //if shipping store is different than selected store 
                    if ($scope.Control.Selected != selectedStore[0].Id) {
                        $scope.Control.Selected = selectedStore[0].Id;
                        $scope.Control.setStore();
                    }
                }

                //if store has grouping and search
                if (!$scope.Control.HasStoreSorting && $scope.Control.HasSearch && checkoutOverrides && checkoutOverrides.Generic && typeof checkoutOverrides.Generic.ResetListSearch === 'function') {
                    //update search in order to display shipping costs
                    angular.element(".x-checkoutstore").ready(function () {
                        checkoutOverrides.Generic.ResetListSearch(searchObj);
                    });
                }
            };

            $scope.Control.addShippingCost = function (storesArray, options) {
                //extend stores model with shipping cost
                storesArray.forEach(function (store) {
                    var selectedOption = _.filter(options, function (x) { return x.StoreId == store.Id; });

                    if (selectedOption.length > 0) {
                        store.hasShippingCost = true;
                        store.CompanyId = selectedOption[0].Id;
                        store.Cost = selectedOption[0].Cost;
                        store.CostText = selectedOption[0].CostText;
                        store.ShippingAndPaymentCost = selectedOption[0].ShippingAndPaymentCost;
                        store.ShippingAndPaymentCostText = selectedOption[0].ShippingAndPaymentCostText;
                    } else {
                        store.hasShippingCost = false;
                    }

                    if ($scope.Control.Selected == store.Id) {
                        angular.extend($scope.Control.Text, store);
                    }
                });
            }

            $element.get(0).validate = function (onComplete) {
                if ($scope.DeliveryPoint.Current.Code !== 'fromStore') {
                    $scope.Control.IsValid = true;
                    if (typeof (onComplete) === 'function') {
                        setTimeout(function () {
                            onComplete($scope.Control.IsValid);
                        }, 200);
                    }
                    return;
                }

                $scope.Control.IsValid = true;

                if (!($scope.PickupPoint && $scope.PickupPoint.Current)) {
                    Validation.require($scope, 'Control.Selected', {
                        defaultValue: '0'
                    }).then(function (response) { }, function (error) { });
                }

                if (typeof (onComplete) === 'function') {
                    setTimeout(function () {
                        onComplete($scope.Control.IsValid);
                    }, 200);
                }

                initiallyValidated = true;
            };

            $element.get(0).set = function () {
                var deferred = $q.defer();

                var selectedStore = $scope.Control.HasStoreSorting ?
                    _.first(_.filter($scope.Model.Data.Stores.Items[0], function (x) { return x.Id == $scope.Control.Selected; })) : _.first(_.filter($scope.Model.Data.Stores, function (x) { return x.Id == $scope.Control.Selected; }));

                ControlService.invokeCheckout($scope, $element, 'SetStore', selectedStore).then(function (setResponse) {
                    $scope.setControlValue(controlName, selectedStore);
                    deferred.resolve(true);
                    $scope.Control.Loading = false;
                }, function (error) {
                    deferred.reject(error);
                    $scope.Control.Loading = false;
                });

                return deferred.promise;
            };

            $element.get(0).data = initialState;

            ControlService.getCheckoutData(controlService, $scope, $element).then(function (response) {
                $scope.Model = {};
                $scope.Control.Text = {};
                angular.extend($scope.Model, response);

                if ($scope.Control.HasStoreSorting) {
                    if ($scope['Order'].Current.GoogleSearchEnabled) {
                        $scope.Control.HasGoogleSearch = true;
                    } else if (checkoutConfig.hasSearch.storesSearch) {
                        $scope.Control.HasSearch = true;
                    }
                } else if (checkoutConfig.hasSearch.storesSearch) {
                    $scope.Control.HasSearch = true;
                }

                var selectedStore;
                var storesArray = $scope.Control.HasStoreSorting ? $scope.Model.Data.Stores.Items[0] : $scope.Model.Data.Stores;

                if ($scope['Order'] && $scope['Order'].Current && $scope['Order'].Current.Store.Id !== 0) {
                    selectedStore = _.first(_.filter(storesArray, function (x) { return x.Id == $scope['Order'].Current.Store.Id; }));
                }

                if (selectedStore) {
                    $scope.Control.Selected = selectedStore.Id;
                    angular.extend($scope.Control.Text, selectedStore || {});
                    $scope.setControlValue(controlName, selectedStore);
                } else if (storesArray.length == 1) {
                    selectedStore = storesArray[0];
                    $scope.Control.Selected = selectedStore.Id;
                    $scope.Control.setStore();
                }

                $scope.Control.Loading = false;
            }, function (error) {
                $scope.Control.Loading = false;
                throw error;
            });

            angular.element($element.get(0)).ready(function () {            
                if ($scope.Control.HasSearch && checkoutOverrides && checkoutOverrides.Generic && typeof checkoutOverrides.Generic.InitListSearch === 'function') {
                    searchObj = checkoutOverrides.Generic.InitListSearch();
                }

                if ($scope.Control.HasStoreSorting && checkoutOverrides && checkoutOverrides.Generic && typeof checkoutOverrides.Generic.InitCustomScrollbar === 'function') {
                    checkoutOverrides.Generic.InitCustomScrollbar($element);
                }

                //on click outside x-checkoutstores - close stores dropdown
                if (!$scope.Control.HasStoreSorting) {
                    $(document).on('click', function (e) {
                        if (!$element.is(e.target) && $element.has(e.target).length === 0) {
                            $scope.Control.hideStores();
                            $scope.$apply();
                        }
                    });
                }
             
            });

        });
})();